export default {"src":"/_next/static/media/user_type.7188d5e4.svg","height":80,"width":82,"blurWidth":0,"blurHeight":0};